/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Add_To_PlanInputs */

const en_recipe_add_to_plan = /** @type {(inputs: Recipe_Add_To_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to plan`)
};

const de_recipe_add_to_plan = /** @type {(inputs: Recipe_Add_To_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einplanen`)
};

/**
* | output |
* | --- |
* | "Add to plan" |
*
* @param {Recipe_Add_To_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_add_to_plan = /** @type {((inputs?: Recipe_Add_To_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Add_To_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_add_to_plan(inputs)
	return en_recipe_add_to_plan(inputs)
});